import SectionTitle from "../../components/SectionTitle";
import Typography from "../../components/Typography";
import React from "react";
import styles from "./Shortcuts.module.css";

const About = () => (
  <div className={styles.wrapper}>
    <SectionTitle>About</SectionTitle>

    <Typography variant="body-small">
      App version:{" "}
      <Typography variant="code">{process.env.REACT_APP_COMMIT_SHA}</Typography>
    </Typography>
  </div>
);

export default About;
